module.exports = __webpack_public_path__ + "img/ar-lang.a753ce0c.svg";